import React, { useState } from 'react'
import { AppBar, Badge, IconButton, Box, useMediaQuery, useTheme } from '@mui/material'
import { Notifications, NotificationsNone, Menu as MenuIcon, NotificationImportant } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import DocsButton from './DocsButton'
import { MENU_STATUS_BIG, NOTIFICATION_COLLECTION, ROLE_ADMIN } from '../../_constants/globals'
import NotificationDrawer from './NotificationDrawer'
import PropTypes from 'prop-types'
import { useFirestore } from '../../hooks/useFirestore'
import useAuth from '../../hooks/useAuth'
import { Account } from '@toolpad/core'
import PopoverContent from './PopoverContent'
import AdminButton from './AdminButton'


const TopBar = ({ setMenuStatus, title }) => {
  
  const profile = useAuth().getProfile()
  const notificationHooks = useFirestore(NOTIFICATION_COLLECTION)
  const dbNotifications = notificationHooks.getDocs()
  const notificationsAllowed = useSelector(state => state.data.notificationsAllowed || false)
  const theme = useTheme()
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'))
  
  const [notificationPanelOpen, setNotificationPanelOpen] = useState(false)
  
  return (
    <AppBar color='primary' position='sticky' elevation={0} sx={{ display: 'block', height: '48px' }}>
      {!isUpMd && <IconButton onClick={() => setMenuStatus(MENU_STATUS_BIG)} sx={{ height: '100%', color: 'white' }}><MenuIcon /></IconButton>}
      {title}
      <Box sx={{ float: 'right' }}>
        {profile.roles.includes(ROLE_ADMIN) && <AdminButton />}
        <DocsButton />
        <IconButton
          aria-label='notifications'
          color='inherit'
          onClick={() => setNotificationPanelOpen(true)}
          size='large'
          sx={{ mr: 1 }}
        >
          <Badge badgeContent={dbNotifications?.filter(n => !n.read).length} color='secondary'>
            {!notificationsAllowed
              ? <NotificationImportant />
              : dbNotifications?.length
                ? <Notifications />
                : <NotificationsNone />
            }
          </Badge>
        </IconButton>
        <NotificationDrawer
          open={notificationPanelOpen}
          onClose={() => setNotificationPanelOpen(false)}
        />
        <Account slots={{ popoverContent: PopoverContent }} slotProps={{ preview: { sx: { display: 'inline' } } }} />
      </Box>
    </AppBar>
  )
}

TopBar.propTypes = {
  setMenuStatus: PropTypes.func.isRequired,
  title: PropTypes.object,
}

export default TopBar
